import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Col, Row } from 'react-grid-system';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {
  FirstRowWrapper, SecondRowWrapper, CarouselWrapper, WeekDay,
  // MobileDateButton
} from './styles';
import Label from '../../../components/shared/Label';
import IconFont from '../../../components/shared/IconFont';
import DateTimeButton from '../../../components/DateTimeButton';

moment.updateLocale('it', null);
moment.updateLocale('it', {
  months: [
    'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio',
    'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
  ],
  weekdaysMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
});

export class NbaTopBar extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.arrow = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nbaCurrentDay !== this.props.nbaCurrentDay) {
      this.arrow.current.style.opacity = '1';
      this.arrow.current.firstChild.childNodes[0].classList.add('orange');
      this.arrow.current.firstChild.childNodes[1].classList.add('orange');
      //console.log('alt', this.arrow.current.childNodes);
      let i = 0;
      for (const el of this.arrow.current.childNodes) {
        if (i > 0 && el.childNodes[0].classList.contains('orange') && el.childNodes[1].classList.contains('orange')) {
          el.childNodes[0].classList.remove('orange');
          el.childNodes[1].classList.remove('orange');
        }
        i += 1;
      }
    }
  }

  getWeekDates = (startDate, daysToAdd) => {
    const arrayDates = [];
    for (let i = 0; i <= daysToAdd; i += 1) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      arrayDates.push(currentDate);
    }
    return arrayDates;
  };

  getShortDay = (day) => {
    const options = { weekday: 'short' };
    return new Date(day).toLocaleString('it-IT', options);
  };

  getCalendar = (date) => {
    const { sportId, competitionId } = window.matchcenterPage;
    this.props.actions.getNbaCalendar(sportId, competitionId, date);
  };

  formatDate = (date) => {
    const options = {
      month: 'long', day: '2-digit', year: 'numeric',
    };
    return new Date(date).toLocaleString('it-IT', options);
  };

  changeDate = (date, dir) => {
    this.arrow.current.style.opacity = '0.5';
    this.arrow.current.firstChild.childNodes[0].classList.remove('orange');
    this.arrow.current.firstChild.childNodes[1].classList.remove('orange');
    // const { sportId, competitionId } = window.matchcenterPage;
    const currentDate = new Date(date);
    switch (dir) {
      case 0: {
        currentDate.setDate(currentDate.getDate() - 7);
        const targetDate = moment(currentDate).format('YYYY-MM-DD');
        window.location.replace(`${window.location.origin}${window.location.pathname}?giornata=${targetDate}`);
        // this.props.actions.getNbaCalendar(sportId, competitionId, currentDate);
        break;
      }
      case 1: {
        currentDate.setDate(currentDate.getDate() + 7);
        const targetDate = moment(currentDate).format('YYYY-MM-DD');
        window.location.replace(`${window.location.origin}${window.location.pathname}?giornata=${targetDate}`);
        // this.props.actions.getNbaCalendar(sportId, competitionId, currentDate);
        break;
      }
      default: {
        const targetDate = moment(currentDate).format('YYYY-MM-DD');
        window.location.replace(`${window.location.origin}${window.location.pathname}?giornata=${targetDate}`);
        // this.props.actions.getNbaCalendar(sportId, competitionId, date);
      }
    }
  };

  handleChange = (date) => {
    // const { sportId, competitionId } = window.matchcenterPage;
    // this.props.actions.getNbaCalendar(sportId, competitionId, date);
    const targetDate = moment(date).format('YYYY-MM-DD');
    window.location.replace(`${window.location.origin}${window.location.pathname}?giornata=${targetDate}`);
    this.toggleCalendar();
  };

  toggleCalendar = (e) => {
    e && e.preventDefault();
  };

  handleChangeMobile = (e) => {
    const { sportId, competitionId } = window.matchcenterPage;
    this.props.actions.getNbaCalendar(sportId, competitionId, e.target.value ? new Date(e.target.value) : new Date());
  };

  render() {
    const {
      nbaCurrentDay,
      isMobile,
    } = this.props;
    const weekDays = this.getWeekDates(new Date(this.props.nbaCurrentDay), 6);
    return (
      <Container
        fluid
        style={{
          marginTop: isMobile ? '1em' : '0em',
          marginBottom: isMobile ? '0.5em' : '1.3em',
          paddingBottom: isMobile ? '12px' : 'none',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <FirstRowWrapper isMobile={isMobile}>
          <Row style={{
            marginLeft: isMobile ? '8px' : '0px',
            marginRight: '0px',
            flexDirection: 'row',
          }}
          >
            <Col
              md={8}
              sm={11}
              xs={11}
              style={{
                paddingLeft: '5px',
                textAlign: 'left',
                overflow: 'visible',
                display: 'flex',
              }}
            >
              <Label
                label={`${this.formatDate(weekDays[0])} - ${this.formatDate(weekDays[6])}`}
                color="black"
                size={0.8}
              />
            </Col>
            <Col
              md={4}
              sm={1}
              xs={1}
              style={{
                paddingRight: '5px',
                justifyContent: 'flex-end',
                overflow: 'visible',
                display: 'flex',
                marginBottom: '5px',
              }}
            >
              {isMobile &&
                <DatePicker
                  customInput={
                    <DateTimeButton
                      color="buttonColor"
                    />}
                  selected={moment(nbaCurrentDay)}
                  onChange={this.handleChange}
                  locale="it"
                  popperPlacement="top-end"
                />
              }
              {/*isMobile &&
                <MobileDateButton>
                  <IconFont
                    className="icon-matchcenter-calendar"
                    color="buttonColor"
                    font={24}
                    marginLeft={0.3}
                    weight="bold"
                    withCursor
                  />
                  <IconFont
                    className="icon-matchcenter-down-arrow"
                    color="buttonColor"
                    font={10}
                    marginLeft={0.5}
                    marginTop={0.6}
                    weight="bold"
                    withCursor
                  />
                  <input
                    type="date"
                    onBlur={e => this.handleChangeMobile(e)}
                    style={{
                        opacity: 0, position: 'absolute', left: '-20px', top: '-2px', height: '30px', width: '50px',
                    }}
                  />
                </MobileDateButton>
              */}
            </Col>
          </Row>
        </FirstRowWrapper>
        <SecondRowWrapper isMobile={isMobile}>
          <Row style={{
            marginLeft: '0px',
            marginRight: '0px',
            flexDirection: 'row',
          }}
          >
            <div
              style={{
                paddingLeft: 0,
                paddingRight: isMobile ? 0 : 15,
                overflow: 'visible',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: isMobile ? 'space-around' : 'flex-start',
                width: isMobile ? '100%' : 'auto',
              }}
            >
              <IconFont
                className="icon-matchcenter-left-arrow-no-margin"
                font={isMobile ? 26 : 28}
                color="linkColor"
                withCursor
                weight="bold"
                textShadow="0px 1px, 1px 0px, 1px 1px"
                onClick={() => this.changeDate(nbaCurrentDay, 0)}
                marginRight={isMobile ? 0 : 0.5}
              />
              <CarouselWrapper innerRef={this.arrow}>
                {weekDays && weekDays.map((day, index) => (
                  <WeekDay
                    isMobile
                    key={index}
                    onClick={(event) => {
                        this.changeDate(day);
                        event.target.parentElement.childNodes[0].classList.add('orange');
                        event.target.parentElement.childNodes[1].classList.add('orange');
                      }
                    }
                    isPointerEvents={index === 0}
                  >
                    <Label
                      size={0.8}
                      label={this.getShortDay(day).toUpperCase()}
                      className={index === 0 && 'orange'}
                    />
                    <Label
                      isTitleNarrowMedium
                      size={0.9}
                      label={day.getDate()}
                      margin="4px 0 0"
                      className={index === 0 && 'orange'}
                    />
                  </WeekDay>
                ))
                }
              </CarouselWrapper>
              <IconFont
                className="icon-matchcenter-right-arrow-no-margin"
                font={isMobile ? 26 : 28}
                color="linkColor"
                withCursor
                weight="bold"
                textShadow="0px 1px, 1px 0px, 1px 1px"
                onClick={() => this.changeDate(nbaCurrentDay, 1)}
                marginLeft={isMobile ? 0 : 0.5}
              />
            </div>
            {!isMobile &&
              <div
                style={{
                  overflow: 'visible',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <DatePicker
                  customInput={
                    <DateTimeButton
                      color="buttonColor"
                    />}
                  selected={moment(nbaCurrentDay)}
                  onChange={this.handleChange}
                  locale="it"
                />
              </div>
            }
          </Row>
        </SecondRowWrapper>
      </Container>
    );
  }
}

NbaTopBar.propTypes = {
  nbaCurrentDay: PropTypes.any,
  isMobile: PropTypes.bool,
  actions: PropTypes.any,
};

export default NbaTopBar;



// WEBPACK FOOTER //
// ./src/containers/BasketCalendarNba/NbaTopBar/index.js